import { Component, OnInit } from '@angular/core';
import { NumberPlatePaymentsService } from 'src/app/services/transit/number-plate-payments.service';

@Component({
  selector: 'app-vehicles-pending-number-plate-pmt',
  templateUrl: './vehicles-pending-number-plate-pmt.component.html',
  styleUrls: ['./vehicles-pending-number-plate-pmt.component.css']
})
export class VehiclesPendingNumberPlatePmtComponent implements OnInit{
  page: number = 1;
  count: number = 0;
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  public warningMessage: string | null = null;
  vehicles: any[] = [];
  searchText: string = '';
  public isLoading: boolean = false;

  constructor(
    private numberPlatePaymentsService:NumberPlatePaymentsService,
  ){}

  ngOnInit(): void {
    this.isLoading=true;
    this.fetchVehicles();
  }

  fetchVehicles():void{
    this.numberPlatePaymentsService.getvehiclesPendingNumberPlatePayment()
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.vehicles = response.data;
          this.isLoading=false;
        }else if(response.status==='no_data'){
           this.errorMessage=response.message;
           this.isLoading=false;
        }else{
          this.errorMessage="Sorry, a problem was encountered while processing your request. Please refresh the page and try again!";
          this.isLoading=false;
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isLoading=false;
      }
    });
  }

  pageChangeEvent(event: number){
    this.page = event;
  }

  onSearchTextChange(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
    this.page = 1; // Reset to page 1 after applying filter
  }
}
